import { Component, Input, EventEmitter } from '@angular/core';

import { FieldWeb } from 'app/shared/model/item.model';

export type FieldActionsType = 'hide' | 'require' | 'clone' | 'delete';

export interface IFieldActionsConfig {
  isVisible: boolean;
  onUpdate: EventEmitter<any>;
}

@Component({
  selector: 'cc-template-field-actions',
  templateUrl: './template-field-actions.component.html',
  styleUrls: ['./template-field-actions.component.scss'],
})
export class TemplateFieldActionsComponent {
  @Input() field: FieldWeb;

  @Input() fieldActionsConfig: Record<FieldActionsType, IFieldActionsConfig>;

  @Input() disabled: boolean;
}
